import yup from 'utils/yup';

export const initialTimeRoundingData = {
  round_clock_in: [] as any,
  clock_in_rounding_direction: 'up',
  clock_in_rounding_increment: '' as any,
  clock_out_rounding_direction: 'nearest',
  clock_out_rounding_increment: '' as any,
  round_clock_out: [] as any,
};
export const timeRoundingSettingsValidation = yup.object().shape({
  clock_in_rounding_increment: yup.string().when('round_clock_in', {
    is: (value: any) => value.length > 0,
    then: yup.string().required(),
  }),
  clock_out_rounding_increment: yup.string().when('round_clock_out', {
    is: (value: any) => value.length > 0,
    then: yup.string().required(),
  }),
});
